export const etsy = {
  oAuthFlowHelp: "Authorise my Etsy shop",
  authSuccess: "The authorisation with Etsy was successful."
};
